// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"88b7917fc93bd84b1167","293":"6acc270ce77ca4476346"}[chunkId] + ".js";
};